// useBrand composable — 品牌元数据（locale-aware）
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { BRAND_LOGO, APP_SLOGAN } from '@/config/brand'

export function useBrand() {
  const { locale, t } = useI18n()

  const name = computed(() => t('app.name'))
  const logoPath = BRAND_LOGO
  const shortSlogan = computed(() => t('app.shortSlogan'))
  const slogan = computed(() => APP_SLOGAN[locale.value] || APP_SLOGAN['zh-CN'])

  return { name, logoPath, slogan, shortSlogan }
}
